import {
  buildExportFileName,
  ExportFileNameUser,
} from "@/v1/utils/exportFileName";

interface DeclarationDownloadNameParams {
  user?: ExportFileNameUser | null;
  declarationName: string;
  taxYear: number;
}

/* "<Customer> - <declaration, umlauts transliterated> - <tax year>.pdf" (SMT-1454). */
export const getDeclarationDownloadName = ({
  user,
  declarationName,
  taxYear,
}: DeclarationDownloadNameParams) =>
  buildExportFileName({
    user: user ?? {},
    exportType: declarationName,
    period: { kind: "year", year: taxYear },
    extension: "pdf",
  });
